var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-center',{attrs:{"caption":"代わりの行動を設定する","action":_vm.setHabitAlternateAction}})}
var staticRenderFns = []

export { render, staticRenderFns }